module.exports = __webpack_public_path__ + "static/media/29FUNOV6.2b81dafb.jpg";